<template>
  <div class="choose-customer">
    <Modal :value="visible" :title="title" :width="modalWidth" @on-cancel="onCancel">
      <Row :gutter="10" v-if="!showSelectedData">
        <Col span="4">
          <Select placeholder="类型" v-model="searchType">
            <Option
              v-for="item in opts"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </Col>
        <Col span="13"><Input search placeholder="客户名称搜索"/></Col>
      </Row>
      <u-table
        :width="tableWidth"
        :height="tableHeight"
        :columns="columns"
        :data="rebuildData"
        @on-selection-change="onSelectionChange"
        style="margin-top: 10px"
      >
      </u-table>

      <div class="u-modal-wrapper" style="" slot="footer">
        <Button type="text" class="expand-btn" @click="toggleSelectedData">{{
          expandText
        }}</Button>
        <Button type="primary" @click="onOk">确定</Button>
        <Button @click="onCancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { deepCopy } from "../../utils/tools";
import { getStoresList } from "@/api/components.js";
export default {
  name: "choose-customer",
  created() {
    this.getAjaxData();
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    checkedId: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableWidth: 760,
      tableHeight: 400,
      visible: this.value,
      showSelectedData: false,
      searchType: "",
      searchVal: "",
      checkedData: this.checkedId, //选中是数据id
      selections: [],
      columns: [
        {
          title: "机构",
          key: "name",
          width: 200
        },
        {
          title: "类型",
          key: "typeName",
          width: 100
        },
        {
          title: "地址",
          key: "address"
        },
        {
          type: "selection",
          width: 60,
          align: "center"
        }
      ],
      tableData: [], //列表数据
      ajaxData: [], //ajax数据
      rebuildData: [],
      opts: [
        {
          value: 1,
          label: "全部"
        },
        {
          value: 2,
          label: "个人"
        },
        {
          value: 3,
          label: "公司"
        }
      ]
    };
  },
  mounted() {
    this.rebuildData = this.makeData();
  },
  updated() {
    //todo 点击已选，关闭弹窗，再次显示弹窗，table宽度渲染不正确
  },
  computed: {
    modalWidth() {
      return this.tableWidth + 32;
    },
    expandText() {
      if (this.showSelectedData) {
        return "收起";
      } else {
        return `已选${this.selections.length}`;
      }
    },
    title() {
      return this.showSelectedData
        ? `已选${this.selections.length}`
        : "选择客户";
    }
  },
  methods: {
    getAjaxData() {
      getStoresList({
        more_place: 1
      })
        .then(res => {
          // console.log(res);
          this.ajaxData = res.data;
          this.tableData = this.formatData(this.ajaxData);
          // console.log(this.tableData);
        })
        .catch(err => {
          console.log(err);
        });
    },
    formatData(ajaxData) {
      return ajaxData.map(item => {
        return {
          id: item.id,
          name: item.stores_name,
          type: item.server_types,
          typeName: item.server_types_name,
          _checked: this.checkedData.includes(item.id),
          address:item.place_lists.length ? item.place_lists.map(obj => {
            return obj.true_place_name;
          }).join(',') : '--'
        };
      });
    },
    onSelectionChange(selection) {
      this.selections = selection.map(item => {
        item._checked = true;
        return item;
      });
    },
    makeData() {
      let data = deepCopy(this.tableData);
      data.forEach((row, index) => {
        row._nodeKey = index;
      });
      return data;
    },
    toggleSelectedData() {
      //显示/隐藏已选数据
      if (!this.showSelectedData && this.selections.length === 0) {
        this.$Message.warning({
          content: "未选择任何数据"
        });
        return;
      }
      this.showSelectedData = !this.showSelectedData;
      if (this.showSelectedData) {
        this.rebuildData = this.selections;
      } else {
        this.rebuildData = this.makeDataWithSelection();
      }
    },
    makeDataWithSelection() {
      let data = this.makeData(),
        checkedIds = this.selections.map(item => {
          return item._nodeKey;
        });
      data.forEach(item => {
        item._checked = checkedIds.indexOf(item._nodeKey) !== -1;
      });
      return data;
    },
    onOk() {
      this.$emit("on-ok", this.selections);
      this.close();
    },
    onCancel() {
      this.close();
    },
    close() {
      this.visible = false;
      this.$emit("on-close");
      this.$emit("input", false);
    }
  },
  watch: {
    tableData: {
      deep: true,
      handler() {
        this.rebuildData = this.makeData();
      }
    },
    checkedId() {
      this.checkedData = this.checkedId;
      this.tableData = this.formatData(this.ajaxData);
    },
    value() {
      this.visible = this.value;
    }
  }
};
</script>
<!--对应外部机构-列表接口-->
